module.exports = __webpack_public_path__ + "media/images/myappbanner-0606759221ea4a9d76d9993fd6c81fb4.png";